const isValidObjectId = (id) => {
  return /^[a-f\d]{24}$/.test(id)
}

module.exports = {
  isValidObjectId,
}
